/** @format */

import * as actionTypes from 'stateContainer/action-types';

const initialState = {
  data: [],
  isFetching: false,
  isError: false
};

export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.NOTIFICATIONS_SUCCESS:
      return { ...state, data: action.payload, isFetching: false };

    case actionTypes.NOTIFICATIONS_ERROR:
      return { ...state, isFetching: false, isError: true };

    case actionTypes.RESET_EMAIL_REDUCER:
      return initialState;

    default:
      return state;
  }
};
